const usaCapitals = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395293, 33.6435655] },
      properties: { state: 'California', capital: 'Record 1' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413544, 33.640261834898695] },
      properties: { state: 'California', capital: 'Record 2' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8412456, 33.634869699999996] },
      properties: { state: 'California', capital: 'Record 3' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8353843, 33.640615350000004] },
      properties: { state: 'California', capital: 'Record 4' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8403564, 33.6352944] },
      properties: { state: 'California', capital: 'Record 5' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8425408, 33.636262099999996] },
      properties: { state: 'California', capital: 'Record 6' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8344054, 33.640471500000004] },
      properties: { state: 'California', capital: 'Record 7' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404737, 33.638944] },
      properties: { state: 'California', capital: 'Record 8' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840614, 33.63473455] },
      properties: { state: 'California', capital: 'Record 9' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843662, 33.6383338] },
      properties: { state: 'California', capital: 'Record 10' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8403627, 33.635763350000005] },
      properties: { state: 'California', capital: 'Record 11' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8402427, 33.63686179923934] },
      properties: { state: 'California', capital: 'Record 12' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840913, 33.6365964] },
      properties: { state: 'California', capital: 'Record 13' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841104, 33.637228] },
      properties: { state: 'California', capital: 'Record 14' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8422154, 33.63638984] },
      properties: { state: 'California', capital: 'Record 15' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367542, 33.63974581063713] },
      properties: { state: 'California', capital: 'Record 16' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8425947, 33.63810615] },
      properties: { state: 'California', capital: 'Record 17' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8383745, 33.6370747] },
      properties: { state: 'California', capital: 'Record 18' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841439, 33.637012] },
      properties: { state: 'California', capital: 'Record 19' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413177, 33.64022051408822] },
      properties: { state: 'California', capital: 'Record 20' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8440541, 33.638635550000004] },
      properties: { state: 'California', capital: 'Record 21' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834423, 33.63982] },
      properties: { state: 'California', capital: 'Record 22' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8422634, 33.636465841394866] },
      properties: { state: 'California', capital: 'Record 23' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8415259, 33.64017804810453] },
      properties: { state: 'California', capital: 'Record 24' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413086, 33.64021018] },
      properties: { state: 'California', capital: 'Record 25' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8386172, 33.6397932] },
      properties: { state: 'California', capital: 'Record 26' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838079, 33.6380155] },
      properties: { state: 'California', capital: 'Record 27' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.833657, 33.63972235] },
      properties: { state: 'California', capital: 'Record 28' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8345089, 33.6401273] },
      properties: { state: 'California', capital: 'Record 29' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8377447, 33.638269449999996] },
      properties: { state: 'California', capital: 'Record 30' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.839454, 33.641689949549196] },
      properties: { state: 'California', capital: 'Record 31' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834831, 33.639912] },
      properties: { state: 'California', capital: 'Record 32' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8379338, 33.63673085] },
      properties: { state: 'California', capital: 'Record 33' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8383987, 33.63901104999999] },
      properties: { state: 'California', capital: 'Record 34' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404212, 33.63677571105559] },
      properties: { state: 'California', capital: 'Record 35' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841403, 33.63479435] },
      properties: { state: 'California', capital: 'Record 36' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8384085, 33.63829] },
      properties: { state: 'California', capital: 'Record 37' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8425062, 33.6390815] },
      properties: { state: 'California', capital: 'Record 38' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8436795, 33.63856065] },
      properties: { state: 'California', capital: 'Record 39' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8424355, 33.63858745] },
      properties: { state: 'California', capital: 'Record 40' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419482, 33.6404565] },
      properties: { state: 'California', capital: 'Record 41' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419411, 33.64032397790374] },
      properties: { state: 'California', capital: 'Record 42' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395487, 33.6407677] },
      properties: { state: 'California', capital: 'Record 43' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367505, 33.63974130752753] },
      properties: { state: 'California', capital: 'Record 44' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8418194, 33.63507185] },
      properties: { state: 'California', capital: 'Record 45' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83555, 33.640314] },
      properties: { state: 'California', capital: 'Record 46' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396127, 33.64156115] },
      properties: { state: 'California', capital: 'Record 47' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8358989, 33.64087615] },
      properties: { state: 'California', capital: 'Record 48' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.837595, 33.63726525] },
      properties: { state: 'California', capital: 'Record 49' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8390841, 33.6392534] },
      properties: { state: 'California', capital: 'Record 50' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8436455, 33.63921035] },
      properties: { state: 'California', capital: 'Record 51' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834605, 33.639433] },
      properties: { state: 'California', capital: 'Record 52' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413223, 33.64022567918953] },
      properties: { state: 'California', capital: 'Record 53' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.839391, 33.642171813628444] },
      properties: { state: 'California', capital: 'Record 54' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8346893, 33.640198350000006] },
      properties: { state: 'California', capital: 'Record 55' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841528, 33.640182] },
      properties: { state: 'California', capital: 'Record 56' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8334924, 33.639628099999996] },
      properties: { state: 'California', capital: 'Record 57' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393647, 33.64238605] },
      properties: { state: 'California', capital: 'Record 58' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8382402, 33.638491349999995] },
      properties: { state: 'California', capital: 'Record 59' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394132, 33.64217162548657] },
      properties: { state: 'California', capital: 'Record 60' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423681, 33.639583099999996] },
      properties: { state: 'California', capital: 'Record 61' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394761, 33.64169180230593] },
      properties: { state: 'California', capital: 'Record 62' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8374687, 33.63838285] },
      properties: { state: 'California', capital: 'Record 63' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396277, 33.642079657554994] },
      properties: { state: 'California', capital: 'Record 64' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8391554, 33.63967605] },
      properties: { state: 'California', capital: 'Record 65' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396497, 33.641970858850435] },
      properties: { state: 'California', capital: 'Record 66' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.84082, 33.6346601] },
      properties: { state: 'California', capital: 'Record 67' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396665, 33.64183887061225] },
      properties: { state: 'California', capital: 'Record 68' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8380984, 33.64147836519137] },
      properties: { state: 'California', capital: 'Record 69' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8416813, 33.6355716] },
      properties: { state: 'California', capital: 'Record 70' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8400846, 33.64113665] },
      properties: { state: 'California', capital: 'Record 71' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834743, 33.639255] },
      properties: { state: 'California', capital: 'Record 72' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398643, 33.640613450000004] },
      properties: { state: 'California', capital: 'Record 73' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8347312, 33.64065345] },
      properties: { state: 'California', capital: 'Record 74' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835503, 33.640494] },
      properties: { state: 'California', capital: 'Record 75' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8361966, 33.64107745] },
      properties: { state: 'California', capital: 'Record 76' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8343389, 33.64000045] },
      properties: { state: 'California', capital: 'Record 77' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.833791, 33.639515] },
      properties: { state: 'California', capital: 'Record 78' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8426506, 33.639143399999995] },
      properties: { state: 'California', capital: 'Record 79' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8415913, 33.63478215] },
      properties: { state: 'California', capital: 'Record 80' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419977, 33.636461875629244] },
      properties: { state: 'California', capital: 'Record 81' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.839377, 33.63975355] },
      properties: { state: 'California', capital: 'Record 82' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8410957, 33.6349501] },
      properties: { state: 'California', capital: 'Record 83' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843512, 33.6391311] },
      properties: { state: 'California', capital: 'Record 84' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8360826, 33.6405312] },
      properties: { state: 'California', capital: 'Record 85' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8386332, 33.639426900000004] },
      properties: { state: 'California', capital: 'Record 86' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395204, 33.64169551] },
      properties: { state: 'California', capital: 'Record 87' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398875, 33.6396755] },
      properties: { state: 'California', capital: 'Record 88' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8418327, 33.63549485] },
      properties: { state: 'California', capital: 'Record 89' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838313, 33.639496550000004] },
      properties: { state: 'California', capital: 'Record 90' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394528, 33.63991715] },
      properties: { state: 'California', capital: 'Record 91' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840655, 33.635663949999994] },
      properties: { state: 'California', capital: 'Record 92' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840393, 33.63659067096868] },
      properties: { state: 'California', capital: 'Record 93' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8405318, 33.638944] },
      properties: { state: 'California', capital: 'Record 94' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8429762, 33.6375308] },
      properties: { state: 'California', capital: 'Record 95' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8390384, 33.63829015] },
      properties: { state: 'California', capital: 'Record 96' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8383676, 33.640103249999996] },
      properties: { state: 'California', capital: 'Record 97' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8399811, 33.635422] },
      properties: { state: 'California', capital: 'Record 98' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8415239, 33.640174096209066] },
      properties: { state: 'California', capital: 'Record 99' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8422572, 33.63672263483871] },
      properties: { state: 'California', capital: 'Record 100' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393766, 33.64077335] },
      properties: { state: 'California', capital: 'Record 101' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413498, 33.64025666979738] },
      properties: { state: 'California', capital: 'Record 102' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8373353, 33.6384409] },
      properties: { state: 'California', capital: 'Record 103' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835002, 33.640381] },
      properties: { state: 'California', capital: 'Record 104' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841378, 33.636838] },
      properties: { state: 'California', capital: 'Record 105' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8432945, 33.63954185] },
      properties: { state: 'California', capital: 'Record 106' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8368952, 33.63778615] },
      properties: { state: 'California', capital: 'Record 107' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.842433, 33.63606791729693] },
      properties: { state: 'California', capital: 'Record 108' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8382477, 33.639073499999995] },
      properties: { state: 'California', capital: 'Record 109' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8392674, 33.64156525] },
      properties: { state: 'California', capital: 'Record 110' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8412774, 33.63447475] },
      properties: { state: 'California', capital: 'Record 111' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834083, 33.639231] },
      properties: { state: 'California', capital: 'Record 112' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8392586, 33.642158391399306] },
      properties: { state: 'California', capital: 'Record 113' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395761, 33.64211778288806] },
      properties: { state: 'California', capital: 'Record 114' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8371401, 33.63758785] },
      properties: { state: 'California', capital: 'Record 115' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8426143, 33.6365833] },
      properties: { state: 'California', capital: 'Record 116' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83494, 33.639552] },
      properties: { state: 'California', capital: 'Record 117' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8406579, 33.6351825] },
      properties: { state: 'California', capital: 'Record 118' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840491, 33.63673751692692] },
      properties: { state: 'California', capital: 'Record 119' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.837555, 33.63874125] },
      properties: { state: 'California', capital: 'Record 120' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419104, 33.6385171] },
      properties: { state: 'California', capital: 'Record 121' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8383536, 33.6384262] },
      properties: { state: 'California', capital: 'Record 122' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8421942, 33.63892705] },
      properties: { state: 'California', capital: 'Record 123' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8402331, 33.636864639391476] },
      properties: { state: 'California', capital: 'Record 124' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.842905, 33.6387733] },
      properties: { state: 'California', capital: 'Record 125' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394129, 33.64010315] },
      properties: { state: 'California', capital: 'Record 126' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8437167, 33.63818835] },
      properties: { state: 'California', capital: 'Record 127' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838107, 33.64141073857295] },
      properties: { state: 'California', capital: 'Record 128' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8414941, 33.635182650000004] },
      properties: { state: 'California', capital: 'Record 129' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8360294, 33.64096135] },
      properties: { state: 'California', capital: 'Record 130' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393468, 33.642169257830396] },
      properties: { state: 'California', capital: 'Record 131' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83365, 33.639437] },
      properties: { state: 'California', capital: 'Record 132' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8373255, 33.63738465] },
      properties: { state: 'California', capital: 'Record 133' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834412, 33.63913] },
      properties: { state: 'California', capital: 'Record 134' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8355342, 33.64073045] },
      properties: { state: 'California', capital: 'Record 135' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834899, 33.64026495] },
      properties: { state: 'California', capital: 'Record 136' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840212, 33.63580295] },
      properties: { state: 'California', capital: 'Record 137' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387975, 33.64109] },
      properties: { state: 'California', capital: 'Record 138' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413282, 33.6375628] },
      properties: { state: 'California', capital: 'Record 139' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8416658, 33.635139699999996] },
      properties: { state: 'California', capital: 'Record 140' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835294, 33.63935] },
      properties: { state: 'California', capital: 'Record 141' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835398, 33.639575] },
      properties: { state: 'California', capital: 'Record 142' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8385831, 33.6390127] },
      properties: { state: 'California', capital: 'Record 143' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8390266, 33.64074675] },
      properties: { state: 'California', capital: 'Record 144' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419026, 33.640305542037495] },
      properties: { state: 'California', capital: 'Record 145' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83498, 33.639998] },
      properties: { state: 'California', capital: 'Record 146' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8403687, 33.63660285396014] },
      properties: { state: 'California', capital: 'Record 147' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393494, 33.64111665] },
      properties: { state: 'California', capital: 'Record 148' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387226, 33.638910100000004] },
      properties: { state: 'California', capital: 'Record 149' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841313, 33.637186] },
      properties: { state: 'California', capital: 'Record 150' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835561, 33.640103] },
      properties: { state: 'California', capital: 'Record 151' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8350192, 33.640865899999994] },
      properties: { state: 'California', capital: 'Record 152' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841843, 33.63648465] },
      properties: { state: 'California', capital: 'Record 153' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8418958, 33.64029127101875] },
      properties: { state: 'California', capital: 'Record 154' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8429608, 33.63821815] },
      properties: { state: 'California', capital: 'Record 155' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8397363, 33.64072755] },
      properties: { state: 'California', capital: 'Record 156' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8429861, 33.63734305] },
      properties: { state: 'California', capital: 'Record 157' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404561, 33.63675661399126] },
      properties: { state: 'California', capital: 'Record 158' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83527, 33.639719] },
      properties: { state: 'California', capital: 'Record 159' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8371302, 33.6420691] },
      properties: { state: 'California', capital: 'Record 160' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843134, 33.6382284] },
      properties: { state: 'California', capital: 'Record 161' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393027, 33.64216382461485] },
      properties: { state: 'California', capital: 'Record 162' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8388661, 33.64080305] },
      properties: { state: 'California', capital: 'Record 163' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423696, 33.6378668] },
      properties: { state: 'California', capital: 'Record 164' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834712, 33.638821] },
      properties: { state: 'California', capital: 'Record 165' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840823, 33.63519195] },
      properties: { state: 'California', capital: 'Record 166' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8401492, 33.636710411525556] },
      properties: { state: 'California', capital: 'Record 167' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8375487, 33.6438755] },
      properties: { state: 'California', capital: 'Record 168' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8380465, 33.636434550000004] },
      properties: { state: 'California', capital: 'Record 169' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8390779, 33.641544800000005] },
      properties: { state: 'California', capital: 'Record 170' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8431667, 33.6394576] },
      properties: { state: 'California', capital: 'Record 171' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.837324, 33.63805165] },
      properties: { state: 'California', capital: 'Record 172' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8403606, 33.63660691495729] },
      properties: { state: 'California', capital: 'Record 173' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834926, 33.639275] },
      properties: { state: 'California', capital: 'Record 174' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840022, 33.6397911] },
      properties: { state: 'California', capital: 'Record 175' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8376165, 33.63832915] },
      properties: { state: 'California', capital: 'Record 176' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8389838, 33.64107425] },
      properties: { state: 'California', capital: 'Record 177' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8427218, 33.6369344] },
      properties: { state: 'California', capital: 'Record 178' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8349296, 33.64075735] },
      properties: { state: 'California', capital: 'Record 179' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8357082, 33.64121165] },
      properties: { state: 'California', capital: 'Record 180' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843037, 33.63936835] },
      properties: { state: 'California', capital: 'Record 181' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8370636, 33.63814335] },
      properties: { state: 'California', capital: 'Record 182' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394484, 33.63895395] },
      properties: { state: 'California', capital: 'Record 183' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8355729, 33.6411204] },
      properties: { state: 'California', capital: 'Record 184' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8420665, 33.636756950000006] },
      properties: { state: 'California', capital: 'Record 185' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8385259, 33.638219899999996] },
      properties: { state: 'California', capital: 'Record 186' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367523, 33.639743559082326] },
      properties: { state: 'California', capital: 'Record 187' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8434238, 33.639649649999996] },
      properties: { state: 'California', capital: 'Record 188' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423522, 33.636891399999996] },
      properties: { state: 'California', capital: 'Record 189' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8400986, 33.64124975] },
      properties: { state: 'California', capital: 'Record 190' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8408269, 33.63566185] },
      properties: { state: 'California', capital: 'Record 191' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396321, 33.642057897814084] },
      properties: { state: 'California', capital: 'Record 192' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367962, 33.6419981] },
      properties: { state: 'California', capital: 'Record 193' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838996, 33.642271449999996] },
      properties: { state: 'California', capital: 'Record 194' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8424235, 33.638011500000005] },
      properties: { state: 'California', capital: 'Record 195' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8338255, 33.63981505] },
      properties: { state: 'California', capital: 'Record 196' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8383624, 33.6408731] },
      properties: { state: 'California', capital: 'Record 197' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.842223, 33.636055] },
      properties: { state: 'California', capital: 'Record 198' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394999, 33.64216331183813] },
      properties: { state: 'California', capital: 'Record 199' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387704, 33.6393272] },
      properties: { state: 'California', capital: 'Record 200' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8416593, 33.639342] },
      properties: { state: 'California', capital: 'Record 201' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835099, 33.640273] },
      properties: { state: 'California', capital: 'Record 202' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8415198, 33.64016619241813] },
      properties: { state: 'California', capital: 'Record 203' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413699, 33.6395893] },
      properties: { state: 'California', capital: 'Record 204' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8420559, 33.63944375] },
      properties: { state: 'California', capital: 'Record 205' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835098, 33.638903] },
      properties: { state: 'California', capital: 'Record 206' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8393247, 33.64216654122262] },
      properties: { state: 'California', capital: 'Record 207' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394798, 33.64217106106096] },
      properties: { state: 'California', capital: 'Record 208' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396409, 33.642014378332256] },
      properties: { state: 'California', capital: 'Record 209' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404823, 33.63674229119301] },
      properties: { state: 'California', capital: 'Record 210' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83782, 33.63863515] },
      properties: { state: 'California', capital: 'Record 211' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395189, 33.642151929600615] },
      properties: { state: 'California', capital: 'Record 212' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8370204, 33.637708849999996] },
      properties: { state: 'California', capital: 'Record 213' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396603, 33.64190519037209] },
      properties: { state: 'California', capital: 'Record 214' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8392807, 33.64216110800708] },
      properties: { state: 'California', capital: 'Record 215' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419226, 33.6386975] },
      properties: { state: 'California', capital: 'Record 216' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8358205, 33.640090900000004] },
      properties: { state: 'California', capital: 'Record 217' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396453, 33.641992618591345] },
      properties: { state: 'California', capital: 'Record 218' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423405, 33.63641895] },
      properties: { state: 'California', capital: 'Record 219' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8385574, 33.6401878] },
      properties: { state: 'California', capital: 'Record 220' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834003, 33.639571] },
      properties: { state: 'California', capital: 'Record 221' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396644, 33.64186097719887] },
      properties: { state: 'California', capital: 'Record 222' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8421183, 33.63660484787232] },
      properties: { state: 'California', capital: 'Record 223' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8390707, 33.640269599999996] },
      properties: { state: 'California', capital: 'Record 224' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8378659, 33.63819585] },
      properties: { state: 'California', capital: 'Record 225' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8402609, 33.635054749999995] },
      properties: { state: 'California', capital: 'Record 226' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404374, 33.6397659] },
      properties: { state: 'California', capital: 'Record 227' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367449, 33.63973455286314] },
      properties: { state: 'California', capital: 'Record 228' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396583, 33.641927296958706] },
      properties: { state: 'California', capital: 'Record 229' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834128, 33.639685] },
      properties: { state: 'California', capital: 'Record 230' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8381036, 33.63690545] },
      properties: { state: 'California', capital: 'Record 231' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8385256, 33.64145845] },
      properties: { state: 'California', capital: 'Record 232' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394097, 33.64168624403573] },
      properties: { state: 'California', capital: 'Record 233' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413269, 33.64023084429083] },
      properties: { state: 'California', capital: 'Record 234' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841359, 33.640267] },
      properties: { state: 'California', capital: 'Record 235' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8391932, 33.64073745] },
      properties: { state: 'California', capital: 'Record 236' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8352155, 33.6409746] },
      properties: { state: 'California', capital: 'Record 237' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843065, 33.6377078] },
      properties: { state: 'California', capital: 'Record 238' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8351, 33.639601] },
      properties: { state: 'California', capital: 'Record 239' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423423, 33.6389916] },
      properties: { state: 'California', capital: 'Record 240' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8405124, 33.638944] },
      properties: { state: 'California', capital: 'Record 241' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398663, 33.64044945] },
      properties: { state: 'California', capital: 'Record 242' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404931, 33.638944] },
      properties: { state: 'California', capital: 'Record 243' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394313, 33.6415411] },
      properties: { state: 'California', capital: 'Record 244' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8366894, 33.63966700621919] },
      properties: { state: 'California', capital: 'Record 245' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.836316, 33.64157515] },
      properties: { state: 'California', capital: 'Record 246' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8397681, 33.6403142] },
      properties: { state: 'California', capital: 'Record 247' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8380863, 33.63913165] },
      properties: { state: 'California', capital: 'Record 248' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834231, 33.638983] },
      properties: { state: 'California', capital: 'Record 249' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8381118, 33.64137699085836] },
      properties: { state: 'California', capital: 'Record 250' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8361191, 33.6417643] },
      properties: { state: 'California', capital: 'Record 251' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840495, 33.6351918] },
      properties: { state: 'California', capital: 'Record 252' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8376516, 33.6376313] },
      properties: { state: 'California', capital: 'Record 253' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8368254, 33.641760500000004] },
      properties: { state: 'California', capital: 'Record 254' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8379128, 33.6420915] },
      properties: { state: 'California', capital: 'Record 255' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.841889, 33.640277] },
      properties: { state: 'California', capital: 'Record 256' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8376937, 33.6386982] },
      properties: { state: 'California', capital: 'Record 257' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.836746, 33.637332650000005] },
      properties: { state: 'California', capital: 'Record 258' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8397897, 33.642193000000006] },
      properties: { state: 'California', capital: 'Record 259' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8423869, 33.640469100000004] },
      properties: { state: 'California', capital: 'Record 260' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8425858, 33.6386513] },
      properties: { state: 'California', capital: 'Record 261' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8410908, 33.6344852] },
      properties: { state: 'California', capital: 'Record 262' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8371718, 33.63807185] },
      properties: { state: 'California', capital: 'Record 263' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8435709, 33.63972375] },
      properties: { state: 'California', capital: 'Record 264' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8401068, 33.640902999999994] },
      properties: { state: 'California', capital: 'Record 265' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398384, 33.6354678] },
      properties: { state: 'California', capital: 'Record 266' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8409847, 33.6399247] },
      properties: { state: 'California', capital: 'Record 267' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396142, 33.642095018413016] },
      properties: { state: 'California', capital: 'Record 268' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8373228, 33.636932099999996] },
      properties: { state: 'California', capital: 'Record 269' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835671, 33.639876] },
      properties: { state: 'California', capital: 'Record 270' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8389585, 33.639716] },
      properties: { state: 'California', capital: 'Record 271' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8377122, 33.64173875] },
      properties: { state: 'California', capital: 'Record 272' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8402561, 33.63985595] },
      properties: { state: 'California', capital: 'Record 273' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8380028, 33.6381262] },
      properties: { state: 'California', capital: 'Record 274' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8368853, 33.6414985] },
      properties: { state: 'California', capital: 'Record 275' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8363182, 33.6419613] },
      properties: { state: 'California', capital: 'Record 276' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413407, 33.64024633959476] },
      properties: { state: 'California', capital: 'Record 277' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8424435, 33.6376743] },
      properties: { state: 'California', capital: 'Record 278' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8401409, 33.636714058644166] },
      properties: { state: 'California', capital: 'Record 279' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8418507, 33.6394076] },
      properties: { state: 'California', capital: 'Record 280' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8366027, 33.6415457] },
      properties: { state: 'California', capital: 'Record 281' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8432307, 33.638966100000005] },
      properties: { state: 'California', capital: 'Record 282' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395277, 33.64113065] },
      properties: { state: 'California', capital: 'Record 283' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838947, 33.63928425] },
      properties: { state: 'California', capital: 'Record 284' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396541, 33.641949099109524] },
      properties: { state: 'California', capital: 'Record 285' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8439746, 33.63876335] },
      properties: { state: 'California', capital: 'Record 286' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8338351, 33.640209999999996] },
      properties: { state: 'California', capital: 'Record 287' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8362913, 33.6404125] },
      properties: { state: 'California', capital: 'Record 288' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387147, 33.64024245] },
      properties: { state: 'California', capital: 'Record 289' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8409625, 33.635569000000004] },
      properties: { state: 'California', capital: 'Record 290' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8425961, 33.637562849999995] },
      properties: { state: 'California', capital: 'Record 291' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.843792, 33.63933055] },
      properties: { state: 'California', capital: 'Record 292' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8405348, 33.635747] },
      properties: { state: 'California', capital: 'Record 293' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8374638, 33.637310049999996] },
      properties: { state: 'California', capital: 'Record 294' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.839835, 33.63907275] },
      properties: { state: 'California', capital: 'Record 295' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8409361, 33.634543] },
      properties: { state: 'California', capital: 'Record 296' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8372031, 33.637484549999996] },
      properties: { state: 'California', capital: 'Record 297' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8357341, 33.640797199999994] },
      properties: { state: 'California', capital: 'Record 298' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834886, 33.638889] },
      properties: { state: 'California', capital: 'Record 299' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8340766, 33.64032915] },
      properties: { state: 'California', capital: 'Record 300' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.839274, 33.64020715] },
      properties: { state: 'California', capital: 'Record 301' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394354, 33.64217144] },
      properties: { state: 'California', capital: 'Record 302' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8364918, 33.6421458] },
      properties: { state: 'California', capital: 'Record 303' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.842014, 33.63628643] },
      properties: { state: 'California', capital: 'Record 304' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404092, 33.636582548974374] },
      properties: { state: 'California', capital: 'Record 305' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398987, 33.6394397] },
      properties: { state: 'California', capital: 'Record 306' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8376165, 33.6379252] },
      properties: { state: 'California', capital: 'Record 307' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8431018, 33.64012505] },
      properties: { state: 'California', capital: 'Record 308' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8419568, 33.640326397918415] },
      properties: { state: 'California', capital: 'Record 309' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840435, 33.638944] },
      properties: { state: 'California', capital: 'Record 310' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8367486, 33.63973905597273] },
      properties: { state: 'California', capital: 'Record 311' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8417734, 33.639886849999996] },
      properties: { state: 'California', capital: 'Record 312' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387106, 33.641471300000006] },
      properties: { state: 'California', capital: 'Record 313' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8396883, 33.6410811] },
      properties: { state: 'California', capital: 'Record 314' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83427, 33.63931] },
      properties: { state: 'California', capital: 'Record 315' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.83535, 33.6410676] },
      properties: { state: 'California', capital: 'Record 316' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8379659, 33.63859975] },
      properties: { state: 'California', capital: 'Record 317' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8397761, 33.6415554] },
      properties: { state: 'California', capital: 'Record 318' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8404648, 33.63675183972517] },
      properties: { state: 'California', capital: 'Record 319' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.842237, 33.63950245] },
      properties: { state: 'California', capital: 'Record 320' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8394052, 33.63820065] },
      properties: { state: 'California', capital: 'Record 321' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.838465, 33.639452399999996] },
      properties: { state: 'California', capital: 'Record 322' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8433723, 33.6390338] },
      properties: { state: 'California', capital: 'Record 323' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8391725, 33.64110895] },
      properties: { state: 'California', capital: 'Record 324' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8420255, 33.6387969] },
      properties: { state: 'California', capital: 'Record 325' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.840101, 33.641412] },
      properties: { state: 'California', capital: 'Record 326' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8427594, 33.638696499999995] },
      properties: { state: 'California', capital: 'Record 327' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8392171, 33.63821585] },
      properties: { state: 'California', capital: 'Record 328' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8395425, 33.64169736057613] },
      properties: { state: 'California', capital: 'Record 329' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8342872, 33.64038545] },
      properties: { state: 'California', capital: 'Record 330' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8340086, 33.639888] },
      properties: { state: 'California', capital: 'Record 331' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8381165, 33.6385608] },
      properties: { state: 'California', capital: 'Record 332' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834777, 33.639485] },
      properties: { state: 'California', capital: 'Record 333' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8382545, 33.6417049] },
      properties: { state: 'California', capital: 'Record 334' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8387831, 33.639771100000004] },
      properties: { state: 'California', capital: 'Record 335' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8388916, 33.641506250000006] },
      properties: { state: 'California', capital: 'Record 336' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413315, 33.64023600939215] },
      properties: { state: 'California', capital: 'Record 337' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8377821, 33.6392714] },
      properties: { state: 'California', capital: 'Record 338' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835116, 33.63931] },
      properties: { state: 'California', capital: 'Record 339' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.835145, 33.640049] },
      properties: { state: 'California', capital: 'Record 340' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8427742, 33.63814995] },
      properties: { state: 'California', capital: 'Record 341' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8398922, 33.6418582] },
      properties: { state: 'California', capital: 'Record 342' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8431284, 33.63717925] },
      properties: { state: 'California', capital: 'Record 343' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834653, 33.639858] },
      properties: { state: 'California', capital: 'Record 344' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8413584, 33.6352936] },
      properties: { state: 'California', capital: 'Record 345' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8377098, 33.6378029] },
      properties: { state: 'California', capital: 'Record 346' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834618, 33.64057035] },
      properties: { state: 'California', capital: 'Record 347' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8420113, 33.635431100000005] },
      properties: { state: 'California', capital: 'Record 348' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8374684, 33.638] },
      properties: { state: 'California', capital: 'Record 349' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8411381, 33.64025255] },
      properties: { state: 'California', capital: 'Record 350' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8377864, 33.6442056] },
      properties: { state: 'California', capital: 'Record 351' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.8379552, 33.63922625] },
      properties: { state: 'California', capital: 'Record 352' },
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-117.834922, 33.638644] },
      properties: { state: 'California', capital: 'Record 353' },
    },
  ],
};

export default usaCapitals;
